import React from 'react'

import { BasicForm } from '../../../../core/components/form'
import { usePutForm, useFetch } from '../../../../hooks/manager/project'
import { useHistory, useParams } from 'react-router-dom'

import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

import Form, { ValidationSchema } from './form'

const Formulario = () => {
  const { id } = useParams()
  const { data, isLoading, isError } = useFetch(id)
  const update = usePutForm(id)
  const history = useHistory()

  function handleSubmit (values, bag) {
    const form = { ...values }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const initialValues = {
    code: data.project.code,
    name: data.project.name,
    description: data.project.description,
    client: (data.client && data.client.id) ? data.client.id : '',
    first_name: data.project.first_name,
    last_name: data.project.last_name,
    phone: data.project.phone,
    email: data.project.email,
    skype: data.project.skype,
    satisfaction_survey: data.project.satisfaction_survey
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='EDIT PROJECT'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={(formik) => (
        <Form formik={formik} />
      )}
    />
  )
}

export default Formulario
